/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ values: NonNullable<unknown> }} Downloadlinkslast7daysvalues4Inputs */

const en_downloadlinkslast7daysvalues4 = /** @type {(inputs: Downloadlinkslast7daysvalues4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Clicks per day, oldest first: ${i?.values}`)
};

const de_downloadlinkslast7daysvalues4 = /** @type {(inputs: Downloadlinkslast7daysvalues4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Klicks pro Tag, älteste zuerst: ${i?.values}`)
};

/**
* | output |
* | --- |
* | "Clicks per day, oldest first: {values}" |
*
* @param {Downloadlinkslast7daysvalues4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinkslast7daysvalues4 = /** @type {((inputs: Downloadlinkslast7daysvalues4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinkslast7daysvalues4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinkslast7daysvalues4(inputs)
	return de_downloadlinkslast7daysvalues4(inputs)
});
export { downloadlinkslast7daysvalues4 as "downloadLinksLast7DaysValues" }